import { createReducer, on } from "@ngrx/store";
import { TutorDeleteState, initialTutorDeleteState } from "./tutor-delete.state";
import { DeleteTutor, DeleteTutorError, DeleteTutorSuccess, ResetDeleteTutorProps } from "./tutor-delete.actions";

export const TutorDeleteReducers = createReducer(
    initialTutorDeleteState,
    on(DeleteTutor, (state): TutorDeleteState => {
        return {
            ...state,
            deleteTutorResult: null,
            deleteTutorLoader: true,
            deleteTutorError: null,
        }
    }),
    on(DeleteTutorSuccess, (state, action): TutorDeleteState => {
        return {
            ...state,
            deleteTutorResult: action.result,
            deleteTutorLoader: false,
        }
    }),
    on(DeleteTutorError, (state, action): TutorDeleteState => {
        return {
            ...state,
            deleteTutorLoader: false,
            deleteTutorError: action.error,
        }
    }),
    on(ResetDeleteTutorProps, (state): TutorDeleteState => {
        return {
            ...state,
            deleteTutorResult: null,
            deleteTutorLoader: false,
            deleteTutorError: null,
        }
    }),
)